(() => {
  'use strict';
  const element = document.getElementById('EnginoraChannelsPromoConfig');
  if (!element) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch (_) { return; }
  const startsAt = Date.parse(config.startsAt);
  const endsAt = Date.parse(config.endsAt);
  const validSchedule = Number.isFinite(startsAt) && Number.isFinite(endsAt) && endsAt - startsAt === 72 * 60 * 60 * 1000;
  if (!validSchedule || config.baseCents !== 37425 || config.offerCents !== 28900) return;
  const locale = String(config.locale || '').startsWith('ar') ? 'ar-SA-u-ca-gregory-nu-latn' : 'en-GB';
  const dateFormat = new Intl.DateTimeFormat(locale, {
    timeZone: 'Asia/Riyadh', day: 'numeric', month: 'long', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  const moneyFormat = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const upcomingText = String(config.upcoming || '').replace('__START__', dateFormat.format(new Date(startsAt)));
  const activeText = String(config.active || '').replace('__END__', dateFormat.format(new Date(endsAt)));
  let timer;
  function setMoney(node, cents) {
    if (!node || node.dataset.moneyCents === String(cents)) return false;
    node.dataset.moneyCents = String(cents);
    node.textContent = moneyFormat.format(cents / 100) + ' SAR';
    return true;
  }
  function refresh() {
    window.clearTimeout(timer);
    const now = Date.now();
    const active = now >= startsAt && now < endsAt;
    const upcoming = now < startsAt;
    let pricesChanged = false;
    document.querySelectorAll('[data-channels-promo]').forEach(container => {
      if (container.dataset.productId !== config.productId || container.dataset.variantId !== config.variantId ||
          Number(container.dataset.baseCents) !== config.baseCents || container.dataset.moneySource !== 'SAR') return;
      const price = container.querySelector('[data-product-price] [data-display-money]');
      const compare = container.querySelector('[data-product-compare]');
      const compareMoney = compare?.querySelector('[data-display-money]');
      const compareLabel = container.querySelector('[data-promo-compare-label]');
      const note = container.querySelector('[data-promo-note]');
      if (!price || !compare || !compareMoney || !note) return;
      const originalCompare = Number(container.dataset.compareCents);
      if (!Number.isSafeInteger(originalCompare) || originalCompare < 0) return;
      const currentPrice = Number(price.dataset.moneyCents);
      if (currentPrice !== config.baseCents && currentPrice !== config.offerCents) {
        note.hidden = true;
        return;
      }
      const shownPrice = active ? config.offerCents : config.baseCents;
      const shownCompare = active ? config.baseCents : originalCompare;
      if (setMoney(price, shownPrice)) pricesChanged = true;
      if (setMoney(compareMoney, shownCompare)) pricesChanged = true;
      compare.hidden = shownCompare <= shownPrice;
      if (compareLabel) compareLabel.textContent = active ? config.beforeOffer : config.saleLabel;
      const noteText = active ? activeText : upcoming ? upcomingText : '';
      if (note.textContent !== noteText) note.textContent = noteText;
      note.hidden = !noteText;
      container.dataset.promoActive = String(active);
    });
    if (pricesChanged) document.dispatchEvent(new Event('enginora:prices-updated'));
    const nextBoundary = upcoming ? startsAt : active ? endsAt : 0;
    if (nextBoundary) timer = window.setTimeout(refresh, Math.min(60000, Math.max(25, nextBoundary - now)));
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  refresh();
})();
